import clsx from "clsx"
import { GenericBoxWithLabelsProps } from "./genericBox.types"
import './styles.scss'

export const GenericBoxWithLabels: React.FC<GenericBoxWithLabelsProps> = ({
    ...props
}) => {
    return (
        <div className={clsx("pre-boxWl", {
            "cursor-pointer reduce": props.onClick !== undefined
        })}
            onClick={() => props.onClick && props.onClick()}>
            <div className="generic-boxWl">
                <div>
                    <div className="title">{props.title}</div>
                    <div className="description text-left">{props.description} {props.label1}</div>
                    <div className="description text-left">{props.description2} {props.label2}</div>
                </div>
                <div className="mt-5">
                    {props.child}
                </div>
            </div>
        </div>
    )
}